<script lang="ts">
  import { getContext } from 'svelte';
  import { ArrowIcon } from './components/icons';
  import { slide } from 'svelte/transition';
  import { currentAnswers, showAnswer } from './store/faq';
  import { Wrapper, Heading, Paragraph } from './components';
  import type { UseFormattedProps } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;

  const isEditable = getContext<boolean>('isEditable') || false;

  const onClick = id => {
    showAnswer.set(!$showAnswer);

    if (!$currentAnswers.includes(id)) {
      currentAnswers.update(prev => [...prev, id]);
    } else {
      currentAnswers.update(prev => prev.filter(value => value !== id));
    }
  };
</script>

<Wrapper style="background:var(--vlt-lp-background);">
  {#if properties}
    <div class="faq-section" id={properties?.anchor}>
      <div class="faq-header">
        {#if properties.preamble}
          <div class="preamble">{@html properties.preamble}</div>
        {/if}

        <Heading
          type={'h2'}
          css={'margin-bottom:25px;color:var(--vlt-lp-text);'}
          >{@html properties.heading}</Heading
        >

        <Paragraph css={'color:var(--vlt-lp-text);'}
          >{@html properties.text}</Paragraph
        >
      </div>

      <div class="faq-wrap">
        {#each properties.questions.items as item, index}
          <div class="faq-question-wrap">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div
              class="faq-question-bar"
              role="button"
              tabindex="0"
              style="background:var(--vlt-lp-background);"
              on:click={() => onClick(index)}
            >
              <div class="question-title" style="color:var(--vlt-lp-text);">
                {@html item.question}
              </div>
              <div
                class="arrow-btn {!!$currentAnswers.includes(index) ||
                isEditable
                  ? 'rotate'
                  : ''}"
              >
                <ArrowIcon color="var(--vlt-lp-text)" />
              </div>
            </div>
            {#if !!$currentAnswers.includes(index) || isEditable}
              <div class="faq-content" transition:slide>
                <div class="paragraph">{@html item.answer}</div>
              </div>
            {/if}
          </div>
        {/each}
      </div>
    </div>
  {/if}
</Wrapper>

<style>
  .faq-wrap {
    width: 100%;
    max-width: 750px;
  }
  .question-title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
  }
  .faq-header {
    margin-bottom: 50px;
  }
  .faq-question-wrap:not(:last-of-type) {
    margin-bottom: 35px;
  }
  .faq-section {
    flex-direction: column;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    padding: 0px 15px;
  }
  .preamble {
    margin-bottom: 10px;
    font-weight: 500;
    letter-spacing: 0.25em;
    text-transform: uppercase;
  }
  .paragraph {
    margin-right: 25px;
    margin-bottom: 0;
    margin-left: 25px;
    text-align: left;
    padding-top: 42px;
    padding-bottom: 42px;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: -0.25px;
    color: var(--vlt-lp-text);
    font-family: var(--vlt-lp-paragraph-font);
  }
  .faq-question-bar {
    cursor: pointer;
    height: 60px;
    padding: 10px 25px;
    display: flex;
    text-align: left;
    align-items: center;
    border-radius: 8px;
    text-decoration: none;
    width: auto;
    justify-content: space-between;
  }
  .arrow-btn.rotate {
    transform: rotateZ(-180deg);
  }
  @media screen and (max-width: 640px) {
    .faq-header {
      margin-bottom: 30px;
    }
  }
</style>
